<template>
    <div class="l-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open" @keyup="filterOptions">
      <input v-model="search" >
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(option, i) of dOptions"
        :key="i"
        @click="
          selected = option;
          search = option;
          open = false;
          $emit('input', option);
        "
      >
        {{ option }}
      </div>
     </div>
  </div>
</template>

<script>
  export default {
    props: {
      options: {
        type: Array,
        required: true,
      },
      default: {
        type: String,
        required: false,
        default: null,
      },
      tabindex: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    data() {
      return {
        selected: this.default ? this.default : this.options.length > 0 ? this.options[0] : null,
        search: this.default ? this.default : this.options.length > 0 ? this.options[0] : null,
        open: false,
        dOptions: []
      };
    },
    watch: {
      default: function(newval, oldval){
        this.search = newval  
      }
    },
    methods: {
      filterOptions(){
        this.open = true
        let newOptions = [];
        if(this.search == ''){
          this.dOptions = this.options
        }else{
          this.options.forEach(e =>
            {
              let match = e.toLowerCase().indexOf(this.search) > -1 ||  e.indexOf(this.search) > -1
              if(match){
                e = e[0].toUpperCase() +  e.slice(1);
                newOptions.push(e)
              }
            }
          )
          this.dOptions = newOptions
        }
      }
    },
    mounted() {
      this.dOptions = this.options
      this.$emit("input", this.selected);
    },
};
</script>

<style scoped>
  .l-select {
    position: relative;
    width: 100%;
    text-align: left;
    outline: none;
    height: 42px;
    line-height: 42px;
  }

  .l-select .selected {
    background-color: rgb(255, 255, 255);
    border-radius: 25px;
    border: 2px solid  #171785;
    color: #131381;
    padding-left: 1em;
    cursor: pointer;
    user-select: none;
  }

  .l-select .selected input{
    height: 30px;
    outline: none;
    border: 0;
    width: calc(100% - 20px);
  }

  .l-select .selected.open {
    border: 2px solid  #171785;
    border-radius: 25px 25px 0px 0px;
  }

  .l-select .selected:after {
    position: absolute;
    content: "";
    top: 22px;
    right: 1em;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-color: #131381 transparent transparent transparent;
  }

  .l-select .items {
    color: #131381;
    border-radius: 0px 0px 25px 25px;
    overflow: hidden;
    border-right:2px solid  #171785;
    border-left:2px solid  #171785;
    border-bottom:2px solid  #171785;
    position: absolute;
    background-color: rgb(255, 255, 255);;
    left: 0;
    right: 0;
    z-index: 1;
  }

  .l-select .items div {
    color: #131381;
    padding-left: 1em;
    cursor: pointer;
    user-select: none;
  }

  .l-select .items div:hover {
    background-color: #171785a3;
  }

  .selectHide {
    display: none;
  }
</style>